import { PageViewEventLogger } from '@repo/tracking-service';
import { ReactElement } from 'react';

import s from '@/components/my/common/layout.module.scss';
import { CurrentPasswordForm, NewPasswordForm, TopNavigation } from '@/components/my/password';
import { ChangePasswordProvider, useChangePasswordContext } from '@/components/my/password/contexts/ChangePasswordProvider';

export default function MyPasswordPage() {
  const { step } = useChangePasswordContext();

  return (
    <>
      <TopNavigation />
      <main className={s.main_content}>
        {step === 'current-password' && (
          <PageViewEventLogger pageName={'pw-check'}>
            <CurrentPasswordForm />
          </PageViewEventLogger>
        )}
        {step === 'new-password' && (
          <PageViewEventLogger pageName={'pw-change'}>
            <NewPasswordForm />
          </PageViewEventLogger>
        )}
      </main>
    </>
  );
}

MyPasswordPage.getLayout = function getLayout(page: ReactElement) {
  return <ChangePasswordProvider>{page}</ChangePasswordProvider>;
};
